import React, { useState } from "react";
import "../styles/newsCards.css";
import { useNavigate } from "react-router-dom";

const NewsCards = ({ noticias, basePath = "/noticias", clickable = true }) => {
  return (
    <div className="news-grid">
      {noticias.map((n, i) => (
        <NewsCard
          key={n.id || i}
          noticia={n}
          basePath={basePath}
          clickable={clickable}
        />
      ))}
    </div>
  );
};

const NewsCard = ({ noticia, basePath = "noticias", clickable = true }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const normalizedBasePath = basePath.replace(/^\/+/, "");

  return (
    <div
      className={`news-card ${!clickable ? "no-click" : ""}`}
      onClick={() =>
        clickable && navigate(`/${normalizedBasePath}/${noticia.id}`)
      }
    >
      <div className="news-image-wrapper">
        <img
          src={noticia.imagen}
          alt={noticia.titulo}
          className="news-image"
          loading="lazy"
        />
      </div>

      <div className="news-content">
        <h3 className="news-title">{noticia.titulo}</h3>

        <p className={`news-description ${expanded ? "expanded" : ""}`}>
          {noticia.descripcion}
        </p>

        <button
          className="see-more-btn"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!expanded);
          }}
        >
          {expanded ? "Ver menos" : "Ver más"}
        </button>
      </div>
    </div>
  );
};

export default NewsCards;
